import { render, staticRenderFns } from "./POA.vue?vue&type=template&id=d0684392&scoped=true&"
import script from "./POA.vue?vue&type=script&lang=ts&"
export * from "./POA.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0684392",
  null
  
)

export default component.exports